import script from "./MainSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./MainSearch.vue?vue&type=script&setup=true&lang=js"

import "./MainSearch.vue?vue&type=style&index=0&id=78d26c08&lang=less&scoped=true"

import exportComponent from "/Users/beiyu/Documents/web/森瑶/web/senyao-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78d26c08"]])

export default __exports__